
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"rings","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1233.69 770.64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"id":"ring_4","d":"M173.35 76.73c205-94.83 538.61-93.28 778.8 53.65 223.7 136.85 316.32 291.94 225.53 419.18-84.56 118.53-207.92 203-492.94 202.37-97.09-.2-438.41-50.42-587-214.34-181.33-200.08-44.66-405.23 75.61-460.86z","fill":"none","stroke":"#ebebeb","stroke-width":"4","opacity":".4"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"id":"ring_3","d":"M187.03 134.76c205-94.83 541.93-209.46 782.12-62.53 223.7 136.84 179.78 304.71 120.09 382.43-88.69 115.47-232.57 195.5-359.57 253.85-72.14 33.14-494.34 89.49-642.92-74.42-181.35-200.08-19.99-443.7 100.28-499.33z","fill":"none","stroke":"#ebebeb","stroke-width":"4","opacity":".4"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"id":"ring_2","d":"M183.16 96.34c216.5-173.95 674.6-74.11 905.83 85.17 161 110.9 149.48 328.9 49.1 440.13-76 84.19-186.61 98.11-235.73 109.85-283.32 67.74-551.99-18.21-769.89-233.35-192.11-189.74-26.45-339.81 50.69-401.8z","fill":"none","stroke":"#ebebeb","stroke-width":"4","opacity":".4"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"id":"ring_1","d":"M251.9 134.55c293.05-119.43 572.32-176.83 811.57-29.86 175.44 105.71 209.25 279.89 122 455.2-51.88 100.85-143.44 160.25-218.6 180.3C689.98 830.73-8.63 703.23 2.12 385.06c21.77-95.72 158.13-213.17 249.78-250.51z","fill":"none","stroke":"#ebebeb","stroke-width":"4","opacity":".4"}})])
          )
        }
      }
    